import React from 'react';
import { Link } from 'react-router-dom';
import S from './style';
import Logo from '../../img/sulogo.png'

function Nav(props) {
    return (
        <S.MenuWrapper>
            <S.Logo><img src={Logo} alt="" /></S.Logo>
            <S.Menu>
                <li><Link to="/">Ana Sayfa</Link></li>
                {!props.permission & props.authontication ? <li><Link to="/rapor">Raporlar</Link></li> : false}
                {!props.permission & props.authontication ? <li><Link to="/istatistik">İstatistik</Link></li> : false}
                {props.permission ? <li><Link to="/yonetim">Rapor İşlemleri</Link></li> : false}
                {props.permission ? <li><Link to="/kurumekle">Kurum İşlemleri</Link></li> : false}
                {props.authontication ? <li onClick={props.cikis}><Link to="/"><span className="cikis">Çıkış</span></Link></li> : false}
            </S.Menu>
        </S.MenuWrapper>
    );
}

export default Nav;